import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEraser12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconEraser12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Eraser12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="m6.74 2.355 1.015 1.014-3.312 3.312-1.015-1.015zM5.15 7.388l3.312-3.311 1.015 1.015-3.312 3.311zM2.721 6.373l-.711.712a.5.5 0 0 0 0 .707l2.03 2.03a.5.5 0 0 0 .707 0l.711-.712zM6.74.94l.707.708 2.737 2.736.707.708-.707.707-4.73 4.73a1.5 1.5 0 0 1-2.122 0l-2.03-2.03a1.5 1.5 0 0 1 0-2.121l4.73-4.73zm.915 9.14a.5.5 0 0 0 0 1h2.965a.5.5 0 1 0 0-1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Eraser12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconEraser12);
